// externals
import React from 'react'
import { InstantSearch } from 'react-instantsearch/dom'

// components
import Search from 'components/Search'

// constants
import { credentials } from 'secrets/algolia-key'

const {
	appId,
	apiKey,
} = credentials

const OmniSearch = () => (
	<InstantSearch
		apiKey={apiKey}
		appId={appId}
		indexName='dispensaries'
	>
		<Search />
	</InstantSearch>
)

export default OmniSearch



// WEBPACK FOOTER //
// ./src/components/OmniSearch/index.js